export default __webpack_public_path__ + "static/media/image-work-team-w.3d328398.webp";